<app-dialog [config]="data.config"
            (actionButtonClicked)="onFormSubmit($event)">>
    <ng-container dialog-title>Adjustment</ng-container>

    <ng-container dialog-process-in-progress
                  *ngIf="adjustmentForm && adjustmentForm.form">
        <div class="container">
            <form [formGroup]="adjustmentForm.form">
                <div class="row transfer-details-wrapper">
                    <div class="col-lg-10">
                        <div class="card">
                            <div class="card-body"  *ngIf="data.balanceData?.cashBalances">
                                <span class="label">Balance</span>
                                <ng-container *ngFor="let item of data.balanceData.cashBalances;">
                                    <div class="row">
                                        <div class="col-12 col-lg">
                                            <span class="value">{{ item?.netCash | formatMultiCurrency:'': 2: 2 }} {{item?.currency}}</span>

                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-flex justify-content-center">
                        <a
                            (click)="getAccountDetails()"
                            href="javascript:void(0);" class="cursor-pointer text-primary  d-inline-block pt-lg-3 px-2">
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div [ngClass]="{'mb-3': adjustmentForm.controls.currencies.errors > 0}">
                    <app-select
                        [control]="adjustmentForm.controls.currencies"
                        [formControlName]="adjustmentForm.controls.currencies.name"
                    ></app-select>
                </div>
                <div
                    class="adjustment-amount-input"
                    [ngClass]="{
                    'mb-3': adjustmentForm.controls.amount.errors > 0}">
                    <div class="app-input fill">
                        <app-amount-input [allowNegative] = "true"
                            [control]="adjustmentForm.controls.amount"
                            [formControlName]="adjustmentForm.controls.amount.name">
                        </app-amount-input>
                    </div>
                </div>

                <div [ngClass]="{'mb-3': adjustmentForm.controls.category.errors > 0}">
                    <app-select [formControlName]="adjustmentForm.controls.category.name"
                                [control]="adjustmentForm.controls.category"></app-select>
                </div>

                <div [ngClass]="{'mb-3': adjustmentForm.controls.comment.errors > 0}">
                    <app-panel-input [control]="adjustmentForm.controls.comment"
                                     [formControlName]="adjustmentForm.controls.comment.name"></app-panel-input>
                </div>
            </form>
        </div>
    </ng-container>
</app-dialog>
